'use strict';

function UtilityConfig($stateProvider) {

  'ngInject';

  function _resolveModuleControllers($ocLazyLoad) {

    return $ocLazyLoad.load('UtilityBundle');
  }

  $stateProvider
    .state('main.utilityAbout', {
      url: 'about',
      abstract: true,
      controller: 'UtilityAboutController',
      templateProvider: $templateCache => $templateCache.get('utility-about.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers,
        resolvedPage: function(transObject, apiUtilityService, $rootScope){
          return apiUtilityService
            .getPage('about-video')
            .then(function(res) {

              transObject.translate(res.data);

              if (res.data.translations[$rootScope.lang].showVideo) {
                res.data.type = 'video';
              }
              return res.data;
            });
        }
      }
    })
    .state('main.utilityAbout.about', {
      url: '',
      controller: 'UtilityAboutAboutController',
      resolve: {
        resolvedHTML: function(transObject, apiUtilityService) {
          return apiUtilityService
            .getPage('about')
            .then(function(res) {
              var html = res.data;
              transObject.translate(html);
              return html;
            });
        }
      },
      templateProvider: $templateCache => $templateCache.get('utility-about-about.index.html')
    })
    .state('main.utilityAbout.faq', {
      url: '/faq',
      controller: 'UtilityAboutFaqController',
      resolve: {
        resolvedHTML: function(transObject, apiUtilityService) {
          return apiUtilityService
            .getPage('faq')
            .then(function(res) {
              var html = res.data;
              transObject.translate(html);
              return html;
            });
        }
      },
      templateProvider: $templateCache => $templateCache.get('utility-about-faq.index.html')
    })
    .state('main.utilityAbout.becomeAContributor', {
      url: '/become-a-contributor',
      controller: 'UtilityAboutContributorController',
      resolve: {
        resolvedHTML: function(transObject, apiUtilityService){
          return apiUtilityService
            .getPage('become-contributor')
            .then(function(res) {
              var html = res.data;
              transObject.translate(html);
              return html;
            });
        }
      },
      templateProvider: $templateCache => $templateCache.get('utility-about-contributor.index.html')
    })
    .state('main.utilityAbout.Awards', {
      url: '/awards',
      controller: 'UtilityAboutAwardsController',
      resolve: {
        resolved: function(transObject, apiUtilityService) {

          return apiUtilityService
            .getAwards()
            .then(function(res) {

              var year;
              var years = [];
              var awards = {};

              res.data.items.forEach(function(item) {

                transObject.translate(item);
                var yearParsed = item.awardedAt.substr(0, 4);

                if (yearParsed !== year) {
                  years.push(yearParsed);
                  awards[yearParsed] = [];
                }

                awards[yearParsed].push(item);
                year = yearParsed;
              });

              return { awards, years };
            });
        }
      },
      templateProvider: $templateCache => $templateCache.get('utility-about-awards.index.html')
    })
    .state('main.utilityContact', {
      url: 'contact',
      controller: 'UtilityContactController',
      templateProvider: $templateCache => $templateCache.get('utility-contact.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    })
    .state('main.utilityPrivacy', {
      url: 'privacy',
      abstract: true,
      controller: 'UtilityPrivacyController',
      templateProvider: $templateCache => $templateCache.get('utility-privacy.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    })
    .state('main.utilityPrivacy.policy', {
      url: '',
      controller: 'UtilityPrivacyPolicyController',
      templateProvider: $templateCache => $templateCache.get('utility-privacy-policy.index.html')
    })
    .state('main.utilityPrivacy.cookies', {
      url: '/cookies',
      controller: 'UtilityPrivacyCookiesController',
      templateProvider: $templateCache => $templateCache.get('utility-privacy-cookies.index.html')
    })
    .state('main.utilityPrivacy.terms', {
      url: '/terms-of-service',
      controller: 'UtilityPrivacyTermsController',
      templateProvider: $templateCache => $templateCache.get('utility-privacy-terms.index.html')
    });
}

export default UtilityConfig;



// WEBPACK FOOTER //
// ./app/pages/utility/utility.config.js